import { ContextModalProps } from '@mantine/modals'
import AddWorkForm from 'components/work/WorkForm'
import { useAddWork } from 'hooks/work'
import { NewWork } from 'types/work'

export default function AddWorkModal({ context, id }: ContextModalProps) {
  const addWork = useAddWork()
  async function submit(values: NewWork) {
    await addWork.mutateAsync(values)
  }

  return <AddWorkForm onSubmit={submit} onCancel={() => context.closeModal(id)} type="add" />
}
